import { Dispatch } from '../../types'

/**
 *  Action Constants
 */
export const Expand = 'Monitoring/Fullscreen/Expand';
export const Collapse = 'Monitoring/Fullscreen/Collapse';

/**
 *  Action Type
 */
export type ExpandAction = {
  type: 'Monitoring/Fullscreen/Expand'
}

export type CollapseAction = {
  type: 'Monitoring/Fullscreen/Collapse'
}

/**
 *  Action Creators
 */

export const handleExpand = () => (dispatch: Dispatch) => {
  dispatch({type: Expand })
};

export const handleCollapse = () => (dispatch: Dispatch) => {
  dispatch({type: Collapse })
};

export type FullscreenActions =
  | ExpandAction
  | CollapseAction
